import { RefObject, useEffect, useState } from "react";
import { Bounds, useGesture, Vector2 } from "@use-gesture/react";

const initialDrag: Vector2 = [0, 0];

export const recalculateBoundaries = (
  imageRef: RefObject<HTMLImageElement | null>,
) => {
  if (!imageRef.current) {
    return;
  }

  const height = window.innerHeight;
  const width = window.innerWidth;

  const { width: imageWidth, height: imageHeight } =
    imageRef.current.getBoundingClientRect();

  if (imageWidth > width) {
    return {
      top: height - imageHeight,
      bottom: 0,
      left: width - imageWidth,
      right: 0,
    };
  }

  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  };
};

export const useGalleryGesture = (
  imageRef: RefObject<HTMLImageElement | null>,
): [Vector2, () => void] => {
  const [drag, setDrag] = useState<Vector2>(initialDrag);
  const [bounds, setBounds] = useState<Bounds>();

  useEffect(() => {
    const handler = (e: Event) => e.preventDefault();
    document.addEventListener("gesturestart", handler);
    document.addEventListener("gesturechange", handler);
    document.addEventListener("gestureend", handler);
    return () => {
      document.removeEventListener("gesturestart", handler);
      document.removeEventListener("gesturechange", handler);
      document.removeEventListener("gestureend", handler);
    };
  }, []);

  const resetAdjustments = () => {
    setDrag(initialDrag);
    const bounds = recalculateBoundaries(imageRef);
    setBounds(bounds);
  };

  useGesture(
    {
      onDrag: ({ offset: [dx, dy], pinching, cancel }) => {
        if (pinching) {
          return cancel();
        }

        setDrag([dx, dy]);
      },
    },
    {
      drag: {
        bounds,
        from: drag,
      },
      target: imageRef,
    },
  );

  return [drag, resetAdjustments];
};
